import styled from 'styled-components'

export default styled.article`
  width: 800px;
  border-radius: 4px;
  background-color: ${ ({ theme }) => theme.colors.white };
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 50px;

  > section {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    flex-wrap: nowrap;
    font-size: 18px;
    
    &:hover {
      background-color: #F3F3F3
    }
    
    & a {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 30px 30px;

      & label {
        position: absolute;
        margin-left: 50px;
      }
    }

    & a:hover {
      text-decoration: none;
    }

    & .sectionIcon {
      width: 30px;
      height: 30px;
    }

    & .arrowIcon {
      width: 20px;
      height: 20px;
    }
  }
  
  @media screen and (max-width: 768px){
    width: 100%;
    margin: 0;
    overflow: auto;
  }
`
